import { Zap, Shield, Sparkles, Wrench, Clock, Award, Users, Target } from "lucide-react";

const ITEMS = [
    {
        icon: Zap,
        title: "Rapidez de resposta",
        text: "Atendemos pedidos urgentes e ajustamos a operação ao horário do seu negócio.",
    },
    {
        icon: Award,
        title: "Profissionalismo",
        text: "Equipa formada, métodos eficazes e produtos adequados a cada cenário.",
    },
    {
        icon: Wrench,
        title: "Equipamentos adequados",
        text: "Ferramentas e maquinaria especializada para limpeza técnica em altura e profundidade.",
    },
    {
        icon: Shield,
        title: "Foco na segurança",
        text: "Reduzimos drasticamente o risco de incêndio e cumprimos normas de higiene.",
    },
    {
        icon: Sparkles,
        title: "Resultados visíveis",
        text: "Antes e depois sempre documentado. Sem atalhos, sem desculpas.",
    },
    {
        icon: Users,
        title: "Atendimento personalizado",
        text: "Cada cozinha é diferente. Plano feito à medida do seu equipamento.",
    },
    {
        icon: Clock,
        title: "Manutenção preventiva",
        text: "Planos mensais, trimestrais ou personalizados para nunca falhar.",
    },
    {
        icon: Target,
        title: "Experiência comprovada",
        text: "Restaurantes, hotéis, pastelarias e cozinhas industriais em todo o país.",
    },
];

const WhyChoose = () => {
    return (
        <section
            id="porque-escolher"
            data-testid="why-choose-section"
            className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#F5F5F7]"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
                    <div className="lg:col-span-5 reveal">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="block w-12 h-px bg-[#2E7D5B]" />
                            <span className="label-tag">Diferenciadores</span>
                        </div>
                        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-black uppercase tracking-tighter leading-[0.95] text-[#0A0A0A]">
                            Porque escolher <br />
                            <span className="text-[#9B2C2C]">Lavlimpar.</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 reveal flex items-end">
                        <p className="text-base md:text-lg text-[#0A0A0A]/60 leading-relaxed font-light">
                            Trabalhamos para empresas que não podem dar-se ao luxo de
                            falhar. Por isso, somos rigorosos, rápidos e absolutamente
                            transparentes em cada intervenção.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
                    {ITEMS.map((it, i) => (
                        <div
                            key={it.title}
                            data-testid={`why-item-${i}`}
                            className="group bg-white p-8 hover:bg-[#FAFAFC] transition-colors reveal"
                        >
                            <div className="flex items-center justify-between mb-8">
                                <it.icon className="w-7 h-7 text-[#9B2C2C]" />
                                <span className="label-tag">/ 0{i + 1}</span>
                            </div>
                            <h3 className="font-display text-lg font-bold uppercase tracking-tight mb-3 text-[#0A0A0A]">
                                {it.title}
                            </h3>
                            <p className="text-[#0A0A0A]/55 text-sm leading-relaxed font-light">
                                {it.text}
                            </p>
                            <span className="block mt-6 h-px w-8 bg-black/20 group-hover:w-full group-hover:bg-[#2E7D5B] transition-all duration-500" />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChoose;
